import styled from 'styled-components';

import { Button } from 'components/Button';

const List = styled.ul``;

const ListItem = styled.li`
  margin: 1rem 0;
`;

const ListButton = styled(Button)`
  height: 2.3rem;
`;

export { List, ListItem, ListButton };
